import React, { memo } from 'react'

import {
  ChevronDown, ChevronLeft, ChevronRight, ChevronUp, Icon, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, oneOf } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const toggleIcon = glyph => <Icon svgComponent={glyph} size={iconSize} notSpaced color="darker" />

const ICONS = {
  column: { collapsed: toggleIcon(ChevronDown), expanded: toggleIcon(ChevronUp) },
  strip: { collapsed: toggleIcon(ChevronRight), expanded: toggleIcon(ChevronLeft) },
}

// Shows all the references or only the first few. Expanded, the strip's toggle floats over
// the list's right end.
function Toggle({ layout, isExpanded, onToggle }) {
  const t = useTranslation()

  return (
    <button
      type="button"
      className={classnames(
        'image-references__toggle',
        layout === 'strip' && isExpanded && 'image-references__toggle--floating',
      )}
      aria-expanded={isExpanded}
      aria-label={t(`shared.references.${isExpanded ? 'showFewer' : 'showAll'}`)}
      onClick={onToggle}
    >
      {ICONS[layout][isExpanded ? 'expanded' : 'collapsed']}
    </button>
  )
}

Toggle.propTypes = {
  layout: oneOf(['column', 'strip']).isRequired,
  isExpanded: bool.isRequired,
  onToggle: func.isRequired,
}

export default memo(Toggle)
